import { apiService } from "@/services";
import { settings } from "@/settings";
import { EntitiesClient } from "./GeneratedClients";

const entityRepository = new EntitiesClient(settings.webApi.baseUrl, apiService.getApiClient());

export { entityRepository };
